import type { SVGProps } from "react";

/**
 * LogotipoHorizontal — `wa|som` en línea — encabezados, lockup ancho.
 *
 * Trazado vectorial único (idéntico en las 3 variantes de color del manual de
 * marca — `docs/brand/manual-de-marca.md` §3), vectorizado con potrace desde
 * los assets de 2020. `fill` por defecto es `currentColor`: hereda el color
 * de texto CSS del contenedor. Usar los tokens de marca (`--brand`,
 * `--brand-on`, `#fff`, `#000`) vía `style={{ color: ... }}` o className,
 * o los wrappers de color abajo para los tres tonos oficiales.
 */
export function LogotipoHorizontal(props: SVGProps<SVGSVGElement>) {
  const { fill = "currentColor", ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 3438.000000 896.000000"
      role="img"
      aria-label="WASOM"
      {...rest}
    >
      <g transform="translate(0.000000,896.000000) scale(0.100000,-0.100000)" fill={fill} stroke="none">
        <path d="M14993 8545 c-10 -11 -13 -841 -13 -4075 0 -3507 2 -4063 14 -4076
11 -10 41 -14 110 -14 l96 0 0 4090 0 4090 -97 0 c-72 -1 -101 -5 -110 -15z
M8373 7405 c-19 -22 -18 -291 1 -311 12 -12 110 -14 630 -14 404 0 616 -3 616
-10 0 -6 37 -10 90 -10 53 0 90 -4 90 -10 0 -5 18 -10 40 -10 22 0 40 -4 40
-10 0 -5 14 -10 30 -10 17 0 30 -4 30 -10 0 -5 14 -10 30 -10 17 0 30 -4 30
-10 0 -5 9 -10 20 -10 11 0 20 -4 20 -10 0 -5 9 -10 20 -10 11 0 20 -4 20 -10
0 -5 8 -10 18 -10 10 0 24 -9 32 -20 8 -11 20 -20 27 -20 17 0 203 -186 203
-203 0 -7 9 -19 20 -27 11 -8 20 -22 20 -32 0 -10 5 -18 10 -18 6 0 10 -9 10
-20 0 -11 5 -20 10 -20 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -9 10 -20
0 -11 5 -20 10 -20 6 0 10 -13 10 -30 0 -16 5 -30 10 -30 6 0 10 -18 10 -40 0
-22 5 -40 10 -40 6 0 10 -27 10 -60 0 -33 4 -60 10 -60 7 0 10 -483 10 -1430
0 -947 -3 -1430 -10 -1430 -6 0 -10 -27 -10 -60 0 -33 -4 -60 -10 -60 -5 0
-10 -18 -10 -40 0 -22 -4 -40 -10 -40 -5 0 -10 -13 -10 -30 0 -16 -4 -30 -10
-30 -5 0 -10 -13 -10 -30 0 -16 -4 -30 -10 -30 -5 0 -10 -9 -10 -20 0 -11 -4
-20 -10 -20 -5 0 -10 -8 -10 -18 0 -10 -9 -24 -20 -32 -11 -8 -20 -21 -20 -28
0 -8 -13 -27 -30 -42 -16 -15 -30 -33 -30 -39 0 -15 -106 -121 -121 -121 -6 0
-24 -14 -39 -30 -15 -17 -35 -30 -44 -30 -9 0 -16 -4 -16 -10 0 -5 -9 -10 -20
-10 -11 0 -20 -4 -20 -10 0 -5 -9 -10 -20 -10 -11 0 -20 -4 -20 -10 0 -5 -9
-10 -20 -10 -11 0 -20 -4 -20 -10 0 -5 -13 -10 -30 -10 -16 0 -30 -4 -30 -10
0 -5 -13 -10 -30 -10 -16 0 -30 -4 -30 -10 0 -5 -22 -10 -50 -10 -27 0 -50 -4
-50 -10 0 -7 -197 -10 -570 -10 -373 0 -570 3 -570 10 0 6 -22 10 -50 10 -27
0 -50 5 -50 10 0 6 -13 10 -30 10 -16 0 -30 5 -30 10 0 6 -13 10 -30 10 -16 0
-30 5 -30 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0 6 -9 10 -20 10 -11 0 -20
5 -20 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0 6 -7 10 -16 10 -9 0 -29 14
-44 30 -15 17 -33 30 -39 30 -15 0 -141 126 -141 141 0 6 -13 24 -30 39 -16
15 -30 35 -30 44 0 9 -4 16 -10 16 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0
-10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10
14 -10 30 0 17 -4 30 -10 30 -5 0 -10 18 -10 40 0 22 -4 40 -10 40 -5 0 -10
23 -10 50 0 28 -4 50 -10 50 -7 0 -10 320 -10 940 0 620 3 940 10 940 6 0 10
23 10 50 0 28 5 50 10 50 6 0 10 18 10 40 0 22 5 40 10 40 6 0 10 14 10 30 0
17 5 30 10 30 6 0 10 9 10 20 0 11 5 20 10 20 6 0 10 9 10 20 0 11 5 20 10 20
6 0 10 8 10 18 0 10 9 24 20 32 11 8 20 21 20 30 0 9 9 22 20 30 11 8 20 20
20 27 0 16 85 103 101 103 6 0 28 18 49 40 21 22 46 40 54 40 9 0 16 5 16 10
0 6 9 10 20 10 11 0 20 5 20 10 0 6 9 10 20 10 11 0 20 5 20 10 0 6 9 10 20
10 11 0 20 5 20 10 0 6 9 10 20 10 11 0 20 5 20 10 0 6 18 10 40 10 22 0 40 5
40 10 0 6 18 10 40 10 22 0 40 5 40 10 0 6 37 10 90 10 53 0 90 4 90 10 0 6
80 10 220 10 140 0 220 -4 220 -10 0 -6 30 -10 70 -10 40 0 70 -4 70 -10 0 -5
14 -10 30 -10 17 0 30 -4 30 -10 0 -5 8 -10 18 -10 10 0 24 -9 32 -20 8 -11
20 -20 27 -20 17 0 123 -106 123 -123 0 -7 9 -19 20 -27 12 -8 20 -26 20 -42
0 -15 5 -28 10 -28 6 0 10 -13 10 -30 0 -16 5 -30 10 -30 6 0 10 -30 10 -70 0
-40 4 -70 10 -70 6 0 10 -67 10 -180 l0 -180 -290 0 c-187 0 -290 -4 -290 -10
0 -6 -37 -10 -90 -10 -53 0 -90 -4 -90 -10 0 -5 -18 -10 -40 -10 -22 0 -40 -4
-40 -10 0 -5 -13 -10 -30 -10 -16 0 -30 -4 -30 -10 0 -5 -9 -10 -20 -10 -11 0
-20 -4 -20 -10 0 -5 -9 -10 -20 -10 -11 0 -20 -4 -20 -10 0 -5 -8 -10 -18 -10
-10 0 -24 -9 -32 -20 -8 -11 -21 -20 -28 -20 -7 0 -31 -18 -52 -40 -21 -22
-46 -40 -54 -40 -9 0 -16 -7 -16 -16 0 -8 -18 -33 -40 -54 -22 -21 -40 -45
-40 -52 0 -7 -9 -20 -20 -28 -11 -8 -20 -22 -20 -32 0 -10 -4 -18 -10 -18 -5
0 -10 -9 -10 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -9 -10 -20 0 -11 -4 -20 -10
-20 -5 0 -10 -13 -10 -30 0 -16 -4 -30 -10 -30 -5 0 -10 -13 -10 -30 0 -16 -4
-30 -10 -30 -5 0 -10 -22 -10 -50 0 -27 -4 -50 -10 -50 -6 0 -10 -73 -10 -200
0 -127 4 -200 10 -200 6 0 10 -18 10 -40 0 -22 5 -40 10 -40 6 0 10 -13 10
-30 0 -16 5 -30 10 -30 6 0 10 -13 10 -30 0 -16 5 -30 10 -30 6 0 10 -9 10
-20 0 -11 5 -20 10 -20 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -8 10 -18
0 -10 9 -24 20 -32 11 -8 20 -20 20 -27 0 -17 166 -183 183 -183 7 0 19 -9 27
-20 8 -11 22 -20 32 -20 10 0 18 -4 18 -10 0 -5 9 -10 20 -10 11 0 20 -4 20
-10 0 -5 9 -10 20 -10 11 0 20 -4 20 -10 0 -5 14 -10 30 -10 17 0 30 -4 30
-10 0 -5 9 -10 20 -10 11 0 20 -4 20 -10 0 -5 23 -10 50 -10 28 0 50 -4 50
-10 0 -6 37 -10 90 -10 53 0 90 -4 90 -10 0 -5 23 -10 50 -10 28 0 50 5 50 10
0 6 30 10 70 10 40 0 70 4 70 10 0 6 18 10 40 10 22 0 40 5 40 10 0 6 18 10
40 10 22 0 40 5 40 10 0 6 9 10 20 10 11 0 20 5 20 10 0 6 9 10 20 10 11 0 20
5 20 10 0 6 9 10 20 10 11 0 20 5 20 10 0 6 7 10 16 10 8 0 33 18 54 40 21 22
43 40 50 40 14 0 60 46 60 60 0 7 18 29 40 50 22 21 40 46 40 54 0 9 5 16 10
16 6 0 10 9 10 20 0 11 5 20 10 20 6 0 10 9 10 20 0 11 5 20 10 20 6 0 10 14
10 30 0 17 5 30 10 30 6 0 10 14 10 30 0 17 5 30 10 30 6 0 10 27 10 60 0 33
4 60 10 60 7 0 10 277 10 810 0 533 -3 810 -10 810 -6 0 -10 27 -10 60 0 33
-4 60 -10 60 -5 0 -10 14 -10 30 0 17 -4 30 -10 30 -5 0 -10 14 -10 30 0 17
-4 30 -10 30 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 9 -10 20 0 11 -4
20 -10 20 -5 0 -10 8 -10 18 0 10 -9 24 -20 32 -11 8 -20 20 -20 27 0 19 -186
203 -205 203 -8 0 -15 5 -15 10 0 6 -8 10 -18 10 -10 0 -24 9 -32 20 -8 12
-26 20 -42 20 -15 0 -28 5 -28 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0 6
-13 10 -30 10 -16 0 -30 5 -30 10 0 6 -22 10 -50 10 -27 0 -50 5 -50 10 0 6
-137 10 -390 10 -253 0 -390 -4 -390 -10 0 -6 -27 -10 -60 -10 -33 0 -60 -4
-60 -10 0 -5 -18 -10 -40 -10 -22 0 -40 -4 -40 -10 0 -5 -13 -10 -30 -10 -16
0 -30 -4 -30 -10 0 -5 -13 -10 -30 -10 -16 0 -30 -4 -30 -10 0 -5 -9 -10 -20
-10 -11 0 -20 -4 -20 -10 0 -5 -13 -10 -30 -10 -16 0 -30 -4 -30 -10 0 -5 -8
-10 -18 -10 -10 0 -24 -9 -32 -20 -8 -11 -22 -20 -32 -20 -10 0 -18 -4 -18
-10 0 -5 -8 -10 -18 -10 -10 0 -24 -9 -32 -20 -8 -11 -20 -20 -27 -20 -17 0
-263 -246 -263 -263 0 -7 -9 -19 -20 -27 -11 -8 -20 -21 -20 -30 0 -9 -9 -22
-20 -30 -11 -8 -20 -22 -20 -32 0 -10 -4 -18 -10 -18 -5 0 -10 -9 -10 -20 0
-11 -4 -20 -10 -20 -5 0 -10 -9 -10 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -13
-10 -30 0 -16 -4 -30 -10 -30 -5 0 -10 -9 -10 -20 0 -11 -4 -20 -10 -20 -5 0
-10 -13 -10 -30 0 -16 -4 -30 -10 -30 -5 0 -10 -18 -10 -40 0 -22 -4 -40 -10
-40 -6 0 -10 -27 -10 -60 0 -33 -4 -60 -10 -60 -7 0 -10 -340 -10 -1000 0
-660 3 -1000 10 -1000 6 0 10 -27 10 -60 0 -33 4 -60 10 -60 6 0 10 -18 10
-40 0 -22 5 -40 10 -40 6 0 10 -13 10 -30 0 -16 5 -30 10 -30 6 0 10 -13 10
-30 0 -16 5 -30 10 -30 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -9 10 -20
0 -11 5 -20 10 -20 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -9 10 -20 0
-11 5 -20 10 -20 6 0 10 -7 10 -16 0 -9 14 -29 30 -44 17 -15 30 -33 30 -40 0
-7 13 -25 30 -40 16 -15 30 -33 30 -39 0 -15 126 -141 141 -141 6 0 24 -14 39
-30 15 -17 34 -30 42 -30 7 0 20 -9 28 -20 8 -11 21 -20 30 -20 9 0 22 -9 30
-20 8 -11 22 -20 32 -20 10 0 18 -4 18 -10 0 -5 9 -10 20 -10 11 0 20 -4 20
-10 0 -5 14 -10 30 -10 17 0 30 -4 30 -10 0 -5 9 -10 20 -10 11 0 20 -4 20
-10 0 -5 14 -10 30 -10 17 0 30 -4 30 -10 0 -5 14 -10 30 -10 17 0 30 -4 30
-10 0 -5 23 -10 50 -10 28 0 50 -4 50 -10 0 -6 30 -10 70 -10 40 0 70 -4 70
-10 0 -7 190 -10 550 -10 360 0 550 3 550 10 0 6 30 10 70 10 40 0 70 4 70 10
0 6 23 10 50 10 28 0 50 5 50 10 0 6 14 10 30 10 17 0 30 5 30 10 0 6 14 10
30 10 17 0 30 5 30 10 0 6 9 10 20 10 11 0 20 5 20 10 0 6 9 10 20 10 11 0 20
5 20 10 0 6 13 10 28 10 16 0 34 8 42 20 8 11 22 20 32 20 10 0 18 5 18 10 0
6 8 10 18 10 10 0 24 9 32 20 8 11 21 20 28 20 7 0 31 18 52 40 21 22 43 40
49 40 15 0 101 86 101 101 0 6 18 28 40 49 22 21 40 45 40 52 0 7 9 20 20 28
11 8 20 21 20 30 0 9 9 22 20 30 11 8 20 22 20 32 0 10 5 18 10 18 6 0 10 9
10 20 0 11 5 20 10 20 6 0 10 9 10 20 0 11 5 20 10 20 6 0 10 14 10 30 0 17 5
30 10 30 6 0 10 14 10 30 0 17 5 30 10 30 6 0 10 14 10 30 0 17 5 30 10 30 6
0 10 18 10 40 0 22 5 40 10 40 6 0 10 27 10 60 0 33 4 60 10 60 7 0 10 510 10
1510 0 1000 -3 1510 -10 1510 -6 0 -10 27 -10 60 0 33 -4 60 -10 60 -5 0 -10
18 -10 40 0 22 -4 40 -10 40 -5 0 -10 14 -10 30 0 17 -4 30 -10 30 -5 0 -10
14 -10 30 0 17 -4 30 -10 30 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 13
-10 28 0 16 -8 34 -20 42 -11 8 -20 22 -20 32 0 10 -4 18 -10 18 -5 0 -10 9
-10 20 0 11 -4 20 -10 20 -5 0 -10 7 -10 16 0 9 -13 29 -30 44 -16 15 -30 33
-30 39 0 16 -207 221 -223 221 -7 0 -19 9 -27 20 -8 11 -21 20 -30 20 -9 0
-22 9 -30 20 -8 11 -22 20 -32 20 -10 0 -18 5 -18 10 0 6 -9 10 -20 10 -11 0
-20 5 -20 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0 6 -9 10 -20 10 -11 0 -20
5 -20 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0 6 -13 10 -30 10 -16 0 -30 5
-30 10 0 6 -13 10 -30 10 -16 0 -30 5 -30 10 0 6 -18 10 -40 10 -22 0 -40 5
-40 10 0 6 -27 10 -60 10 -33 0 -60 4 -60 10 0 7 -242 10 -707 10 -599 -1
-710 -3 -720 -15z m1327 -2975 c0 -227 -4 -350 -10 -350 -6 0 -10 -27 -10 -60
0 -33 -4 -60 -10 -60 -5 0 -10 -13 -10 -30 0 -16 -4 -30 -10 -30 -5 0 -10 -7
-10 -15 0 -20 -145 -165 -165 -165 -8 0 -15 -4 -15 -10 0 -5 -9 -10 -20 -10
-11 0 -20 -4 -20 -10 0 -5 -9 -10 -20 -10 -11 0 -20 -4 -20 -10 0 -5 -22 -10
-50 -10 -27 0 -50 -4 -50 -10 0 -6 -37 -10 -90 -10 -53 0 -90 4 -90 10 0 6
-18 10 -40 10 -22 0 -40 5 -40 10 0 6 -18 10 -40 10 -22 0 -40 5 -40 10 0 6
-8 10 -18 10 -10 0 -24 9 -32 20 -8 11 -20 20 -27 20 -19 0 -123 106 -123 125
0 8 -4 15 -10 15 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 9 -10 20 0 11
-4 20 -10 20 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 18 -10 40 0 22 -4
40 -10 40 -6 0 -10 47 -10 120 0 73 4 120 10 120 6 0 10 18 10 40 0 22 5 40
10 40 6 0 10 18 10 40 0 22 5 40 10 40 6 0 10 9 10 20 0 11 5 20 10 20 6 0 10
7 10 16 0 9 14 29 30 44 17 15 30 35 30 44 0 9 7 16 16 16 8 0 33 18 54 40 21
22 46 40 54 40 9 0 16 5 16 10 0 6 14 10 30 10 17 0 30 5 30 10 0 6 14 10 30
10 17 0 30 5 30 10 0 6 117 10 330 10 l330 0 0 -350z M20240 6170 c0 -6 -37
-10 -90 -10 -53 0 -90 -4 -90 -10 0 -5 -18 -10 -40 -10 -22 0 -40 -4 -40 -10
0 -5 -13 -10 -30 -10 -16 0 -30 -4 -30 -10 0 -5 -13 -10 -30 -10 -16 0 -30 -4
-30 -10 0 -5 -9 -10 -20 -10 -11 0 -20 -4 -20 -10 0 -5 -8 -10 -18 -10 -10 0
-24 -9 -32 -20 -8 -11 -21 -20 -30 -20 -9 0 -22 -9 -30 -20 -8 -11 -20 -20
-27 -20 -16 0 -123 -105 -123 -121 0 -6 -18 -28 -40 -49 -22 -21 -40 -46 -40
-54 0 -9 -4 -16 -10 -16 -5 0 -10 -9 -10 -20 0 -11 -4 -20 -10 -20 -5 0 -10
-8 -10 -18 0 -10 -9 -24 -20 -32 -12 -8 -20 -26 -20 -42 0 -15 -4 -28 -10 -28
-5 0 -10 -18 -10 -40 0 -22 -4 -40 -10 -40 -5 0 -10 -22 -10 -50 0 -27 -4 -50
-10 -50 -6 0 -10 -50 -10 -130 0 -80 4 -130 10 -130 6 0 10 -18 10 -40 0 -22
5 -40 10 -40 6 0 10 -18 10 -40 0 -22 5 -40 10 -40 6 0 10 -9 10 -20 0 -11 5
-20 10 -20 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -9 10 -20 0 -11 5 -20
10 -20 6 0 10 -7 10 -16 0 -9 14 -29 30 -44 17 -15 30 -33 30 -39 0 -16 147
-161 163 -161 7 0 19 -9 27 -20 8 -11 21 -20 28 -20 8 0 27 -13 42 -30 15 -16
35 -30 44 -30 9 0 16 -4 16 -10 0 -5 9 -10 20 -10 11 0 20 -4 20 -10 0 -5 9
-10 20 -10 11 0 20 -4 20 -10 0 -5 14 -10 30 -10 17 0 30 -4 30 -10 0 -5 9
-10 20 -10 11 0 20 -4 20 -10 0 -5 9 -10 20 -10 11 0 20 -4 20 -10 0 -5 9 -10
20 -10 11 0 20 -4 20 -10 0 -5 14 -10 30 -10 17 0 30 -4 30 -10 0 -5 9 -10 20
-10 11 0 20 -4 20 -10 0 -5 9 -10 20 -10 11 0 20 -4 20 -10 0 -5 9 -10 20 -10
11 0 20 -4 20 -10 0 -5 14 -10 30 -10 17 0 30 -4 30 -10 0 -5 9 -10 20 -10 11
0 20 -4 20 -10 0 -5 9 -10 20 -10 11 0 20 -4 20 -10 0 -5 9 -10 20 -10 11 0
20 -4 20 -10 0 -5 13 -10 28 -10 16 0 34 -8 42 -20 8 -11 22 -20 32 -20 10 0
18 -4 18 -10 0 -5 8 -10 18 -10 10 0 24 -9 32 -20 8 -11 21 -20 28 -20 8 0 27
-13 42 -30 15 -16 33 -30 39 -30 16 0 101 -87 101 -103 0 -7 9 -19 20 -27 11
-8 20 -22 20 -32 0 -10 5 -18 10 -18 6 0 10 -13 10 -30 0 -16 5 -30 10 -30 6
0 10 -18 10 -40 0 -22 5 -40 10 -40 6 0 10 -30 10 -70 0 -40 -4 -70 -10 -70
-5 0 -10 -22 -10 -50 0 -27 -4 -50 -10 -50 -5 0 -10 -13 -10 -30 0 -16 -4 -30
-10 -30 -5 0 -10 -7 -10 -16 0 -9 -13 -29 -30 -44 -16 -15 -30 -33 -30 -39 0
-17 -67 -81 -85 -81 -8 0 -15 -4 -15 -10 0 -5 -9 -10 -20 -10 -11 0 -20 -4
-20 -10 0 -5 -9 -10 -20 -10 -11 0 -20 -4 -20 -10 0 -5 -9 -10 -20 -10 -11 0
-20 -4 -20 -10 0 -5 -22 -10 -50 -10 -27 0 -50 -4 -50 -10 0 -6 -50 -10 -130
-10 -80 0 -130 4 -130 10 0 6 -22 10 -50 10 -27 0 -50 5 -50 10 0 6 -18 10
-40 10 -22 0 -40 5 -40 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0 6 -9 10 -20
10 -11 0 -20 5 -20 10 0 6 -7 10 -15 10 -20 0 -165 145 -165 165 0 8 -4 15
-10 15 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 9 -10 20 0 11 -4 20 -10
20 -5 0 -10 18 -10 40 0 22 -4 40 -10 40 -5 0 -10 18 -10 40 0 22 -4 40 -10
40 -6 0 -10 33 -10 80 0 47 -4 80 -10 80 -5 0 -10 9 -10 20 0 13 -7 20 -20 20
-11 0 -20 5 -20 10 0 6 -53 10 -140 10 -87 0 -140 -4 -140 -10 0 -5 -9 -10
-20 -10 -13 0 -20 -7 -20 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -13 -10 -30 0
-16 5 -30 10 -30 6 0 10 -33 10 -80 0 -47 4 -80 10 -80 6 0 10 -22 10 -50 0
-27 5 -50 10 -50 6 0 10 -13 10 -30 0 -16 5 -30 10 -30 6 0 10 -13 10 -30 0
-16 5 -30 10 -30 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -9 10 -20 0 -11
5 -20 10 -20 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -8 10 -18 0 -10 9
-24 20 -32 11 -8 20 -21 20 -28 0 -7 18 -31 40 -52 22 -21 40 -43 40 -50 0
-14 46 -60 60 -60 7 0 29 -18 50 -40 21 -22 45 -40 52 -40 7 0 20 -9 28 -20 8
-11 22 -20 32 -20 10 0 18 -4 18 -10 0 -5 9 -10 20 -10 11 0 20 -4 20 -10 0
-5 9 -10 20 -10 11 0 20 -4 20 -10 0 -5 9 -10 20 -10 11 0 20 -4 20 -10 0 -5
18 -10 40 -10 22 0 40 -4 40 -10 0 -5 18 -10 40 -10 22 0 40 -4 40 -10 0 -6
27 -10 60 -10 33 0 60 -4 60 -10 0 -6 50 -10 130 -10 80 0 130 4 130 10 0 6
27 10 60 10 33 0 60 4 60 10 0 6 18 10 40 10 22 0 40 5 40 10 0 6 14 10 30 10
17 0 30 5 30 10 0 6 9 10 20 10 11 0 20 5 20 10 0 6 13 10 28 10 16 0 34 8 42
20 8 11 22 20 32 20 10 0 18 5 18 10 0 6 7 10 16 10 9 0 29 13 44 30 15 16 33
30 39 30 15 0 121 106 121 121 0 6 14 24 30 39 17 15 30 34 30 42 0 7 9 20 20
28 11 8 20 22 20 32 0 10 5 18 10 18 6 0 10 9 10 20 0 11 5 20 10 20 6 0 10
14 10 30 0 17 5 30 10 30 6 0 10 14 10 30 0 17 5 30 10 30 6 0 10 18 10 40 0
22 5 40 10 40 6 0 10 60 10 160 0 100 -4 160 -10 160 -5 0 -10 18 -10 40 0 22
-4 40 -10 40 -5 0 -10 18 -10 40 0 22 -4 40 -10 40 -5 0 -10 9 -10 20 0 11 -4
20 -10 20 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 9 -10 20 0 11 -4 20
-10 20 -5 0 -10 8 -10 18 0 10 -9 24 -20 32 -11 8 -20 20 -20 27 0 16 -185
203 -201 203 -6 0 -24 14 -39 30 -15 17 -35 30 -44 30 -9 0 -16 5 -16 10 0 6
-9 10 -20 10 -11 0 -20 5 -20 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0 6 -9
10 -20 10 -11 0 -20 5 -20 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0 6 -9 10
-20 10 -11 0 -20 5 -20 10 0 6 -13 10 -30 10 -16 0 -30 5 -30 10 0 6 -9 10
-20 10 -11 0 -20 5 -20 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0 6 -13 10
-30 10 -16 0 -30 5 -30 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0 6 -13 10
-30 10 -16 0 -30 5 -30 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0 6 -9 10 -20
10 -11 0 -20 5 -20 10 0 6 -13 10 -30 10 -16 0 -30 5 -30 10 0 6 -9 10 -20 10
-11 0 -20 5 -20 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0 6 -9 10 -20 10 -11
0 -20 5 -20 10 0 6 -8 10 -18 10 -10 0 -24 9 -32 20 -8 11 -21 20 -30 20 -9 0
-22 9 -30 20 -8 11 -20 20 -27 20 -19 0 -163 146 -163 165 0 8 -4 15 -10 15
-5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5
0 -10 23 -10 50 0 28 -4 50 -10 50 -5 0 -10 18 -10 40 0 22 5 40 10 40 6 0 10
27 10 60 0 33 4 60 10 60 6 0 10 14 10 30 0 17 5 30 10 30 6 0 10 8 10 18 0
10 9 24 20 32 11 8 20 20 20 27 0 17 86 103 103 103 7 0 19 9 27 20 8 11 22
20 32 20 10 0 18 5 18 10 0 6 9 10 20 10 11 0 20 5 20 10 0 6 14 10 30 10 17
0 30 5 30 10 0 6 23 10 50 10 28 0 50 5 50 10 0 6 40 10 100 10 60 0 100 -4
100 -10 0 -5 23 -10 50 -10 28 0 50 -4 50 -10 0 -5 14 -10 30 -10 17 0 30 -4
30 -10 0 -5 9 -10 20 -10 11 0 20 -4 20 -10 0 -5 7 -10 16 -10 8 0 33 -18 54
-40 21 -22 46 -40 54 -40 9 0 16 -7 16 -16 0 -9 14 -29 30 -44 17 -15 30 -35
30 -44 0 -9 5 -16 10 -16 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -13 10
-30 0 -16 5 -30 10 -30 6 0 10 -13 10 -30 0 -16 5 -30 10 -30 6 0 10 -30 10
-70 0 -40 4 -70 10 -70 6 0 10 -12 10 -26 0 -50 15 -54 194 -54 159 0 166 1
166 20 0 11 5 20 10 20 6 0 10 23 10 50 0 28 -4 50 -10 50 -6 0 -10 30 -10 70
0 40 -4 70 -10 70 -5 0 -10 23 -10 50 0 28 -4 50 -10 50 -5 0 -10 14 -10 30 0
17 -4 30 -10 30 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 14 -10 30 0 17
-4 30 -10 30 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 8 -10 18 0 10 -9
24 -20 32 -11 8 -20 21 -20 28 0 7 -18 31 -40 52 -22 21 -40 46 -40 54 0 9 -7
16 -16 16 -8 0 -37 23 -64 50 -27 28 -56 50 -64 50 -9 0 -16 5 -16 10 0 6 -9
10 -20 10 -11 0 -20 5 -20 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0 6 -9 10
-20 10 -11 0 -20 5 -20 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0 6 -18 10
-40 10 -22 0 -40 5 -40 10 0 6 -18 10 -40 10 -22 0 -40 5 -40 10 0 6 -40 10
-100 10 -60 0 -100 4 -100 10 0 6 -22 10 -50 10 -27 0 -50 -4 -50 -10z M25880
6170 c0 -6 -37 -10 -90 -10 -53 0 -90 -4 -90 -10 0 -5 -22 -10 -50 -10 -27 0
-50 -4 -50 -10 0 -5 -9 -10 -20 -10 -11 0 -20 -4 -20 -10 0 -5 -13 -10 -30
-10 -16 0 -30 -4 -30 -10 0 -5 -9 -10 -20 -10 -11 0 -20 -4 -20 -10 0 -5 -9
-10 -20 -10 -11 0 -20 -4 -20 -10 0 -5 -9 -10 -20 -10 -11 0 -20 -4 -20 -10 0
-5 -7 -10 -16 -10 -9 0 -29 -13 -44 -30 -15 -16 -33 -30 -39 -30 -15 0 -141
-126 -141 -141 0 -6 -13 -24 -30 -39 -16 -15 -30 -34 -30 -42 0 -7 -9 -20 -20
-28 -11 -8 -20 -22 -20 -32 0 -10 -4 -18 -10 -18 -5 0 -10 -9 -10 -20 0 -11
-4 -20 -10 -20 -5 0 -10 -13 -10 -30 0 -16 -4 -30 -10 -30 -5 0 -10 -9 -10
-20 0 -11 -4 -20 -10 -20 -5 0 -10 -18 -10 -40 0 -22 -4 -40 -10 -40 -5 0 -10
-18 -10 -40 0 -22 -4 -40 -10 -40 -7 0 -10 -303 -10 -890 0 -587 3 -890 10
-890 6 0 10 -22 10 -50 0 -27 5 -50 10 -50 6 0 10 -13 10 -30 0 -16 5 -30 10
-30 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -13 10 -30 0 -16 5 -30 10
-30 6 0 10 -8 10 -18 0 -10 9 -24 20 -32 11 -8 20 -22 20 -32 0 -10 5 -18 10
-18 6 0 10 -7 10 -16 0 -9 14 -29 30 -44 17 -15 30 -33 30 -39 0 -15 126 -141
141 -141 6 0 24 -13 39 -30 15 -16 35 -30 44 -30 9 0 16 -4 16 -10 0 -5 8 -10
18 -10 10 0 24 -9 32 -20 8 -12 26 -20 42 -20 15 0 28 -4 28 -10 0 -5 9 -10
20 -10 11 0 20 -4 20 -10 0 -5 14 -10 30 -10 17 0 30 -4 30 -10 0 -5 23 -10
50 -10 28 0 50 -4 50 -10 0 -6 37 -10 90 -10 53 0 90 -4 90 -10 0 -5 23 -10
50 -10 28 0 50 5 50 10 0 6 37 10 90 10 53 0 90 4 90 10 0 6 18 10 40 10 22 0
40 5 40 10 0 6 14 10 30 10 17 0 30 5 30 10 0 6 14 10 30 10 17 0 30 5 30 10
0 6 9 10 20 10 11 0 20 5 20 10 0 6 8 10 18 10 10 0 24 9 32 20 8 11 21 20 30
20 9 0 22 9 30 20 8 11 20 20 27 20 17 0 183 166 183 183 0 7 9 19 20 27 11 8
20 21 20 30 0 9 9 22 20 30 11 8 20 22 20 32 0 10 5 18 10 18 6 0 10 9 10 20
0 11 5 20 10 20 6 0 10 9 10 20 0 11 5 20 10 20 6 0 10 14 10 30 0 17 5 30 10
30 6 0 10 14 10 30 0 17 5 30 10 30 6 0 10 18 10 40 0 22 5 40 10 40 6 0 10
37 10 90 0 53 4 90 10 90 7 0 10 250 10 730 0 480 -3 730 -10 730 -6 0 -10 37
-10 90 0 53 -4 90 -10 90 -5 0 -10 18 -10 40 0 22 -4 40 -10 40 -5 0 -10 14
-10 30 0 17 -4 30 -10 30 -5 0 -10 14 -10 30 0 17 -4 30 -10 30 -5 0 -10 9
-10 20 0 11 -4 20 -10 20 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 9 -10
20 0 11 -4 20 -10 20 -5 0 -10 7 -10 16 0 9 -13 29 -30 44 -16 15 -30 33 -30
39 0 16 -167 181 -183 181 -7 0 -19 9 -27 20 -8 11 -22 20 -32 20 -10 0 -18 5
-18 10 0 6 -8 10 -18 10 -10 0 -24 9 -32 20 -8 12 -26 20 -42 20 -15 0 -28 5
-28 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0 6 -13 10 -30 10 -16 0 -30 5
-30 10 0 6 -22 10 -50 10 -27 0 -50 5 -50 10 0 6 -33 10 -80 10 -47 0 -80 4
-80 10 0 6 -22 10 -50 10 -27 0 -50 -4 -50 -10z m180 -380 c0 -5 18 -10 40
-10 22 0 40 -4 40 -10 0 -5 13 -10 28 -10 16 0 34 -8 42 -20 8 -11 22 -20 32
-20 10 0 18 -4 18 -10 0 -5 7 -10 15 -10 19 0 145 -124 145 -143 0 -7 9 -19
20 -27 11 -8 20 -22 20 -32 0 -10 5 -18 10 -18 6 0 10 -13 10 -30 0 -16 5 -30
10 -30 6 0 10 -13 10 -30 0 -16 5 -30 10 -30 6 0 10 -18 10 -40 0 -22 5 -40
10 -40 7 0 10 -277 10 -810 0 -533 -3 -810 -10 -810 -5 0 -10 -18 -10 -40 0
-22 -4 -40 -10 -40 -5 0 -10 -18 -10 -40 0 -22 -4 -40 -10 -40 -5 0 -10 -9
-10 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -8 -10 -18 0 -10 -9 -24 -20 -32 -11
-8 -20 -20 -20 -27 0 -19 -146 -163 -165 -163 -8 0 -15 -4 -15 -10 0 -5 -9
-10 -20 -10 -11 0 -20 -4 -20 -10 0 -5 -13 -10 -30 -10 -16 0 -30 -4 -30 -10
0 -5 -13 -10 -30 -10 -16 0 -30 -4 -30 -10 0 -6 -57 -10 -150 -10 -93 0 -150
4 -150 10 0 6 -18 10 -40 10 -22 0 -40 5 -40 10 0 6 -13 10 -28 10 -16 0 -34
8 -42 20 -8 11 -22 20 -32 20 -10 0 -18 5 -18 10 0 6 -7 10 -15 10 -19 0 -125
104 -125 123 0 7 -9 19 -20 27 -11 8 -20 22 -20 32 0 10 -4 18 -10 18 -5 0
-10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10
18 -10 40 0 22 -4 40 -10 40 -6 0 -10 27 -10 60 0 33 -4 60 -10 60 -7 0 -10
257 -10 750 0 493 3 750 10 750 6 0 10 27 10 60 0 33 4 60 10 60 6 0 10 18 10
40 0 22 5 40 10 40 6 0 10 9 10 20 0 11 5 20 10 20 6 0 10 9 10 20 0 11 5 20
10 20 6 0 10 8 10 18 0 10 9 24 20 32 11 8 20 20 20 27 0 19 106 123 125 123
8 0 15 5 15 10 0 6 9 10 20 10 11 0 20 5 20 10 0 6 9 10 20 10 11 0 20 5 20
10 0 6 9 10 20 10 11 0 20 5 20 10 0 6 18 10 40 10 22 0 40 5 40 10 0 6 53 10
140 10 87 0 140 -4 140 -10z M31520 6170 c0 -6 -33 -10 -80 -10 -47 0 -80 -4
-80 -10 0 -5 -18 -10 -40 -10 -22 0 -40 -4 -40 -10 0 -5 -13 -10 -30 -10 -16
0 -30 -4 -30 -10 0 -5 -9 -10 -20 -10 -11 0 -20 -4 -20 -10 0 -5 -9 -10 -20
-10 -11 0 -20 -4 -20 -10 0 -5 -9 -10 -20 -10 -11 0 -20 -4 -20 -10 0 -5 -7
-10 -16 -10 -9 0 -29 -13 -44 -30 -15 -16 -33 -30 -39 -30 -15 0 -141 -126
-141 -141 0 -6 -13 -24 -30 -39 -16 -15 -30 -35 -30 -44 0 -9 -4 -16 -10 -16
-5 0 -10 -9 -10 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -9 -10 -20 0 -11 -4 -20
-10 -20 -5 0 -10 -9 -10 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -9 -10 -20 0 -11
-4 -20 -10 -20 -5 0 -10 -13 -10 -30 0 -16 -4 -30 -10 -30 -5 0 -10 -13 -10
-30 0 -16 -4 -30 -10 -30 -5 0 -10 -22 -10 -50 0 -27 -4 -50 -10 -50 -7 0 -10
-422 -10 -1246 0 -1066 2 -1247 14 -1260 21 -21 331 -21 352 0 12 13 14 190
14 1230 0 804 3 1216 10 1216 6 0 10 18 10 40 0 22 5 40 10 40 6 0 10 14 10
30 0 17 5 30 10 30 6 0 10 14 10 30 0 17 5 30 10 30 6 0 10 8 10 18 0 10 9 24
20 32 11 8 20 20 20 27 0 19 126 143 145 143 8 0 15 5 15 10 0 6 9 10 20 10
11 0 20 5 20 10 0 6 14 10 30 10 17 0 30 5 30 10 0 6 18 10 40 10 22 0 40 5
40 10 0 6 37 10 90 10 53 0 90 -4 90 -10 0 -5 23 -10 50 -10 28 0 50 -4 50
-10 0 -5 9 -10 20 -10 11 0 20 -4 20 -10 0 -5 9 -10 20 -10 11 0 20 -4 20 -10
0 -5 7 -10 15 -10 19 0 145 -124 145 -143 0 -7 9 -19 20 -27 11 -8 20 -22 20
-32 0 -10 5 -18 10 -18 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -13 10
-30 0 -16 5 -30 10 -30 6 0 10 -22 10 -50 0 -27 5 -50 10 -50 7 0 10 -410 10
-1210 0 -800 3 -1210 10 -1210 6 0 10 -9 10 -20 0 -19 7 -20 166 -20 172 0
194 5 194 44 0 9 5 16 10 16 7 0 10 413 10 1220 0 807 3 1220 10 1220 6 0 10
18 10 40 0 22 5 40 10 40 6 0 10 9 10 20 0 11 5 20 10 20 6 0 10 13 10 28 0
16 8 34 20 42 11 8 20 20 20 27 0 17 146 163 163 163 7 0 19 9 27 20 8 12 26
20 42 20 15 0 28 5 28 10 0 6 18 10 40 10 22 0 40 5 40 10 0 6 40 10 100 10
60 0 100 -4 100 -10 0 -5 18 -10 40 -10 22 0 40 -4 40 -10 0 -5 14 -10 30 -10
17 0 30 -4 30 -10 0 -5 8 -10 18 -10 10 0 24 -9 32 -20 8 -11 20 -20 27 -20
17 0 103 -86 103 -103 0 -7 9 -19 20 -27 11 -8 20 -22 20 -32 0 -10 5 -18 10
-18 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -9 10 -20 0 -11 5 -20 10 -20
6 0 10 -18 10 -40 0 -22 5 -40 10 -40 6 0 10 -27 10 -60 0 -33 4 -60 10 -60 7
0 10 -402 10 -1186 0 -1014 2 -1187 14 -1200 21 -21 331 -21 352 0 12 13 14
191 14 1240 0 811 -3 1226 -10 1226 -6 0 -10 27 -10 60 0 33 -4 60 -10 60 -5
0 -10 14 -10 30 0 17 -4 30 -10 30 -5 0 -10 14 -10 30 0 17 -4 30 -10 30 -5 0
-10 14 -10 30 0 17 -4 30 -10 30 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0
-10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 8 -10 18 0 10 -9 24 -20 32 -11 8
-20 21 -20 28 0 8 -13 27 -30 42 -16 15 -30 33 -30 39 0 15 -86 101 -101 101
-6 0 -24 14 -39 30 -15 17 -34 30 -42 30 -7 0 -20 9 -28 20 -8 11 -22 20 -32
20 -10 0 -18 5 -18 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0 6 -13 10 -30 10
-16 0 -30 5 -30 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0 6 -18 10 -40 10
-22 0 -40 5 -40 10 0 6 -33 10 -80 10 -47 0 -80 4 -80 10 0 6 -18 10 -40 10
-22 0 -40 -4 -40 -10 0 -6 -33 -10 -80 -10 -47 0 -80 -4 -80 -10 0 -5 -18 -10
-40 -10 -22 0 -40 -4 -40 -10 0 -5 -9 -10 -20 -10 -11 0 -20 -4 -20 -10 0 -5
-13 -10 -30 -10 -16 0 -30 -4 -30 -10 0 -5 -7 -10 -16 -10 -9 0 -29 -13 -44
-30 -15 -16 -33 -30 -39 -30 -16 0 -201 -187 -201 -203 0 -7 -9 -19 -20 -27
-11 -8 -20 -22 -20 -32 0 -10 -4 -18 -10 -18 -5 0 -10 -9 -10 -20 0 -13 -7
-20 -20 -20 -13 0 -20 7 -20 20 0 11 -4 20 -10 20 -5 0 -10 8 -10 18 0 10 -9
24 -20 32 -11 8 -20 20 -20 27 0 17 -186 203 -203 203 -7 0 -19 9 -27 20 -8
11 -21 20 -30 20 -9 0 -22 9 -30 20 -8 12 -26 20 -42 20 -15 0 -28 5 -28 10 0
6 -13 10 -30 10 -16 0 -30 5 -30 10 0 6 -18 10 -40 10 -22 0 -40 5 -40 10 0 6
-30 10 -70 10 -40 0 -70 4 -70 10 0 6 -18 10 -40 10 -22 0 -40 -4 -40 -10z
M413 6085 c-17 -18 -19 -2445 -3 -2445 6 0 10 -27 10 -60 0 -33 4 -60 10 -60
6 0 10 -18 10 -40 0 -22 5 -40 10 -40 6 0 10 -13 10 -30 0 -16 5 -30 10 -30 6
0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -13 10 -28 0 -16 8 -34 20 -42 11
-8 20 -22 20 -32 0 -10 5 -18 10 -18 6 0 10 -8 10 -18 0 -10 9 -24 20 -32 11
-8 20 -20 20 -27 0 -17 206 -223 223 -223 7 0 19 -9 27 -20 8 -11 22 -20 32
-20 10 0 18 -4 18 -10 0 -5 9 -10 20 -10 11 0 20 -4 20 -10 0 -5 9 -10 20 -10
11 0 20 -4 20 -10 0 -5 14 -10 30 -10 17 0 30 -4 30 -10 0 -5 23 -10 50 -10
28 0 50 -4 50 -10 0 -6 33 -10 80 -10 47 0 80 -4 80 -10 0 -5 14 -10 30 -10
17 0 30 5 30 10 0 6 37 10 90 10 53 0 90 4 90 10 0 6 14 10 30 10 17 0 30 5
30 10 0 6 9 10 20 10 11 0 20 5 20 10 0 6 9 10 20 10 11 0 20 5 20 10 0 6 9
10 20 10 11 0 20 5 20 10 0 6 9 10 20 10 11 0 20 5 20 10 0 6 7 10 16 10 9 0
29 14 44 30 15 17 33 30 39 30 15 0 101 86 101 101 0 6 14 24 30 39 17 15 30
34 30 42 0 7 9 20 20 28 11 8 20 20 20 28 0 7 7 20 15 28 13 14 17 14 30 0 8
-8 15 -22 15 -30 0 -9 5 -16 10 -16 6 0 10 -7 10 -16 0 -9 13 -29 30 -44 17
-15 30 -33 30 -39 0 -16 127 -141 143 -141 7 0 19 -9 27 -20 8 -11 21 -20 30
-20 9 0 22 -9 30 -20 8 -11 22 -20 32 -20 10 0 18 -4 18 -10 0 -5 14 -10 30
-10 17 0 30 -4 30 -10 0 -5 9 -10 20 -10 11 0 20 -4 20 -10 0 -5 14 -10 30
-10 17 0 30 -4 30 -10 0 -6 33 -10 80 -10 47 0 80 -4 80 -10 0 -5 18 -10 40
-10 22 0 40 5 40 10 0 6 33 10 80 10 47 0 80 4 80 10 0 6 18 10 40 10 22 0 40
5 40 10 0 6 14 10 30 10 17 0 30 5 30 10 0 6 14 10 30 10 17 0 30 5 30 10 0 6
8 10 18 10 10 0 24 9 32 20 8 11 21 20 30 20 9 0 22 9 30 20 8 11 20 20 27 20
16 0 163 145 163 161 0 6 14 24 30 39 17 15 30 34 30 42 0 7 9 20 20 28 11 8
20 22 20 32 0 10 5 18 10 18 6 0 10 9 10 20 0 11 5 20 10 20 6 0 10 14 10 30
0 17 5 30 10 30 6 0 10 9 10 20 0 11 5 20 10 20 6 0 10 18 10 40 0 22 5 40 10
40 6 0 10 18 10 40 0 22 5 40 10 40 6 0 10 40 10 100 0 60 4 100 10 100 7 0
10 387 10 1140 0 753 -3 1140 -10 1140 -5 0 -10 14 -10 30 l0 30 -180 0 c-173
0 -180 -1 -180 -20 0 -11 -4 -20 -10 -20 -7 0 -10 -410 -10 -1210 0 -800 -3
-1210 -10 -1210 -5 0 -10 -22 -10 -50 0 -27 -4 -50 -10 -50 -5 0 -10 -13 -10
-30 0 -16 -4 -30 -10 -30 -5 0 -10 -9 -10 -20 0 -11 -4 -20 -10 -20 -5 0 -10
-8 -10 -18 0 -10 -9 -24 -20 -32 -11 -8 -20 -20 -20 -27 0 -17 -126 -143 -143
-143 -7 0 -19 -9 -27 -20 -8 -12 -26 -20 -42 -20 -15 0 -28 -4 -28 -10 0 -5
-22 -10 -50 -10 -27 0 -50 -4 -50 -10 0 -6 -37 -10 -90 -10 -53 0 -90 4 -90
10 0 6 -18 10 -40 10 -22 0 -40 5 -40 10 0 6 -13 10 -30 10 -16 0 -30 5 -30
10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0 6 -7 10 -15 10 -19 0 -145 124 -145
143 0 7 -9 19 -20 27 -11 8 -20 22 -20 32 0 10 -4 18 -10 18 -5 0 -10 14 -10
30 0 17 -4 30 -10 30 -5 0 -10 14 -10 30 0 17 -4 30 -10 30 -5 0 -10 23 -10
50 0 28 -4 50 -10 50 -7 0 -10 409 -10 1206 0 1031 -2 1207 -14 1220 -21 21
-331 21 -352 0 -12 -13 -14 -182 -14 -1170 0 -764 -3 -1156 -10 -1156 -6 0
-10 -33 -10 -80 0 -47 -4 -80 -10 -80 -5 0 -10 -18 -10 -40 0 -22 -4 -40 -10
-40 -5 0 -10 -13 -10 -30 0 -16 -4 -30 -10 -30 -5 0 -10 -9 -10 -20 0 -11 -4
-20 -10 -20 -5 0 -10 -8 -10 -18 0 -10 -9 -24 -20 -32 -11 -8 -20 -20 -20 -27
0 -17 -86 -103 -103 -103 -7 0 -19 -9 -27 -20 -8 -11 -22 -20 -32 -20 -10 0
-18 -4 -18 -10 0 -5 -13 -10 -30 -10 -16 0 -30 -4 -30 -10 0 -5 -18 -10 -40
-10 -22 0 -40 -4 -40 -10 0 -6 -40 -10 -100 -10 -60 0 -100 4 -100 10 0 6 -18
10 -40 10 -22 0 -40 5 -40 10 0 6 -13 10 -30 10 -16 0 -30 5 -30 10 0 6 -8 10
-18 10 -10 0 -24 9 -32 20 -8 11 -20 20 -27 20 -17 0 -103 86 -103 103 0 7 -9
19 -20 27 -11 8 -20 22 -20 32 0 10 -4 18 -10 18 -5 0 -10 9 -10 20 0 11 -4
20 -10 20 -5 0 -10 14 -10 30 0 17 -4 30 -10 30 -5 0 -10 18 -10 40 0 22 -4
40 -10 40 -6 0 -10 30 -10 70 0 40 -4 70 -10 70 -7 0 -10 395 -10 1166 0 997
-2 1167 -14 1180 -21 20 -335 20 -353 -1z" />
      </g>
    </svg>
  );
}

/** Variante naranja de marca — `--brand` (#FA6900). Uso por defecto. */
export function LogotipoHorizontalNaranja(props: SVGProps<SVGSVGElement>) {
  return <LogotipoHorizontal fill="#FA6900" {...props} />;
}

/** Variante blanca — lockups sobre fondo oscuro o superficies de marca. */
export function LogotipoHorizontalBlanco(props: SVGProps<SVGSVGElement>) {
  return <LogotipoHorizontal fill="#FFFFFF" {...props} />;
}

/** Variante negra — lockups sobre fondo claro donde el naranja no aplica. */
export function LogotipoHorizontalNegro(props: SVGProps<SVGSVGElement>) {
  return <LogotipoHorizontal fill="#17181B" {...props} />;
}
